import {Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {HeaderService} from "@app/shell/header/header.service";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-nav-spacer',
  template: `
    <ng-container *ngIf="height && height > 0">
      <div
        #navSpacer
        class="nav-spacer"
        style="width: 100%;"
        [ngStyle]="{ height: this.height+'px' }"
      ></div>
    </ng-container>
  `,
  styleUrls: ['./nav-spacer.component.scss']
})
export class NavSpacerComponent implements OnInit, AfterViewInit {

  public height:number

  constructor(
    public headerService: HeaderService
  ) {
    this.height = 96
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.headerService.heightChange$.pipe(
      debounceTime(100)
    ).subscribe((height:number)=>{
      this.height = height
    })
  }

}
